const EditorialContent = ({ content, headline }) => {
  if (!content) {
    return null;
  }


  return (
    <div className="mb-6 pb-6 border-b -mx-2 px-2">
      {headline && (
        <div className="font-semibold mb-2">{headline}</div>
      )}
      <div className="">{content}</div>
    </div>
  );
};

export default EditorialContent;
